module.exports = __webpack_public_path__ + "img/icon_return.3a1d0e54.png";